// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dh-dh-klima-spesial-english-wrapper--afaf51f04478a9ef2dcea14746c92f64"};